import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';
import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import { isAuthenticatedUser } from 'js/lib/user';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication-common/constants';
import { getShouldShowUnregisteredOnboarding } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';
import AuthenticationOption from 'bundles/user-account/components/AuthenticationOption';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!../__styles__/index';

type Props = {
  children?: React.ReactNode;
};

const Onboarding2022App = ({ children }: Props) => {
  const shouldShowUnregisteredOnboarding = getShouldShowUnregisteredOnboarding();

  if (!isAuthenticatedUser() && !shouldShowUnregisteredOnboarding) {
    return (
      <AuthenticationOption
        defaultMode={AUTHENTICATION_MODAL_MODES.LOGIN}
        utilizeWebRedirectOnClose
        onCloseRedirectURL="/"
      />
    );
  } else {
    return (
      <StatsigProvider>
        <div className="rc-Onboarding2022App">
          {children}
          <SimpleCourseraMetatags />
        </div>
      </StatsigProvider>
    );
  }
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'onboarding_2022',
        page: 'onboarding_2022',
      },
    };
  }),
  withMarketingConsent
)(Onboarding2022App);
